import { render } from "./MotdModal.vue?vue&type=template&id=0e2b6853&scoped=true"
import script from "./MotdModal.vue?vue&type=script&lang=js"
export * from "./MotdModal.vue?vue&type=script&lang=js"

import "./MotdModal.vue?vue&type=style&index=0&id=0e2b6853&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e2b6853"]])

export default __exports__